import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import WrapperContainer from "../components/WrapperContainer/WrapperContainer.jsx";
import ContractList from "../features/ChoiceContract/ContractList";

import ShimmerMultiLine from "../components/Shimmer/ShimmerMultiLine.jsx";
import Error from "../features/Error.jsx";

import { APP_ROUTES } from "../router";
import { apiFetchContractList } from "../api/methods/contracts.js";

import "../features/ChoiceContract/style.scss";

const ChoiceContract = () => {
  const history = useNavigate();
  const { mobileConnectionInfo } = useSelector(state => state);

  const [contracts, setContracts] = useState([]);
  const [hasError, setHasError] = useState(false);

  const [isFetchData, setIsFetchData] = useState(false);

  useEffect(() => {
    if (!mobileConnectionInfo.apiKey) {
      history(APP_ROUTES.MOBILE_CONNECTION.ROOT_ROUTE, { replace: true });
      return;
    }

    getContractList();
  }, []);

  const getContractList = async () => {
    try {
      setIsFetchData(true);
      const contracts = await apiFetchContractList(mobileConnectionInfo.apiKey);

      if (!contracts.length) {
        setHasError(true);
      } else {
        setContracts(contracts);
      }
    } catch {
      setHasError(true);
    } finally {
      setIsFetchData(false);
    }
  };

  if (isFetchData) return <ShimmerMultiLine count={2} />;
  if (hasError) return <Error />;

  return (
    <>
      <WrapperContainer gap="16" title="sm">
        Выбор договора
      </WrapperContainer>

      <div className="forms-container__content">
        <WrapperContainer gap="24" text="lg">
          У Вас уже есть договор, Вы можете добавить услуги в существующий договор.
        </WrapperContainer>

        <ContractList contracts={contracts} setHasError={setHasError} />
      </div>
    </>
  );
};

export default ChoiceContract;
